const snack = require("../../../../../components/snack/snack");
const purchaseReportOne = require("../purchase/purchase-report-one");

const showError = (id = "downloadError") => snack.start({ act: "show", id });

function hubDetail() {
  return {
    reportPageRightId: "reportHub-report-output",
    skipReportPage: true,
    entity: "purchase",
  };
}

function runPurchasePdf(filters) {
  const id = filters.entityId;
  if (!id) return showError();

  const formData = new FormData();
  formData.append("purchase_id", id);
  formData.append("type", "print");

  fetch(`./server/php/queries/report/purchase/pdf-invoice.php`, {
    method: "POST",
    body: formData,
    credentials: "same-origin",
  })
    .then((response) => {
      if (!response.ok) throw new Error("pdf");
      return response.text();
    })
    .then((pdfFileName) => {
      if (!pdfFileName) return;
      const iframe = document.querySelector("#reportIframe");
      iframe.src = pdfFileName;
      setTimeout(() => iframe.contentWindow.print(), 200);
    })
    .catch(() => showError());
}

export function getData(def, filters) {
  const actions = {
    "purchase-status": () => {
      if (!filters.entityId) return showError();
      purchaseReportOne.start({
        ...hubDetail(),
        source: "hub",
        dbid: filters.entityId,
      });
    },
    "purchase-invoice-pdf": () => runPurchasePdf(filters),
  };

  const action = actions[def.id];
  action ? action() : showError();
}
